import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import TabPanel from '@mui/lab/TabPanel';
import Button from '@mui/material/Button';
import SearchBar from "@mkyy/mui-search-bar";
import { toast } from "react-toastify";
import GroupProductTable from '../../../common/Tables/GroupProductTable';
import { publicAPI, privateAPI } from '../../../utils/api';
import CreateEditGroupDialog from '../../../common/Dialogs/CreateEditGroup';
import CreateEditProductDialog from '../../../common/Dialogs/CreateEditProduct';
import { MuiButtonWrapper } from '../styles';

const AdminGroups = () => {
  const [loading, setLoading] = useState(true);
  const [allGroups, setAllGroups] = useState([]);
  const [rows, setRows] = useState([]);
  const [productsFromGroup, setProductsFromGroup] = useState([]);
  const [isProductGroupOpen, setIsProductGroupOpen] = useState(0);
  const [createGroupOpen, setCreateGroupOpen] = useState(false);
  const [groupDTO, setGroupDTO] = useState({})
  const [createProductOpen, setCreateProductOpen] = useState(false);
  const [productDTO, setProductDTO] = useState({})
  const [editProductGroupId, setEditProductGroupId] = useState();

  const requestSearch = (searchedVal) => {
    const filteredRows = allGroups.filter((row) => {
      return row.name.toLowerCase().includes(searchedVal.toLowerCase());
    });
    filteredRows.length > 0 ? setRows(filteredRows) : setRows([{id: 'No data', name: 'No data', description: 'No data', image: 'No data'}])
  };

  const getAllGroups = async () => {
    setLoading(true);

    try{
        const response = await publicAPI.get(`/public/bacchus/productgroup`);
        setAllGroups(response.data);
        setRows(response.data);
        setLoading(false);
    } catch (error){
        setLoading(false);
        if(error.request.status === 500) return toast.error('Internal server error')
    }
  } 

  const getProductsFromGroup = async (id) => {
    setLoading(true);
    setIsProductGroupOpen(id);
    setProductsFromGroup([]);

    try{
        const response = await publicAPI.get(`/public/bacchus/product?product_group_id=${id}`);
        setProductsFromGroup(response.data);
        setLoading(false);
    } catch (error){
        setLoading(false);
        if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const closeAccording = () => {
    setIsProductGroupOpen(0);
    setProductsFromGroup([]);
  }

  const openEditGroup = async (id) => {
    setIsProductGroupOpen(0);

    try {
      const response = await privateAPI.get(`/public/bacchus/productgroup/${id}`);
      setGroupDTO(response.data)
      setCreateGroupOpen(true)
    } catch (error){
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const editGroup = async () => {
    if(!groupDTO.name) return toast.info('Name is required');
    // if(!groupDTO.description) return toast.info('Description is required');

    try {
      setLoading(true);
      await privateAPI.put(`/auth/bacchus/admin/productgroup/${groupDTO.id}`, groupDTO);
      getAllGroups();
      setGroupDTO({});
      setCreateGroupOpen(false);
      setLoading(false);
    } catch (error){
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const crateNewGroup = async () => {
    if(!groupDTO.name) return toast.info('Name is required');
    if(!groupDTO.description) return toast.info('Description is required');
    
    const productGroupDTO = groupDTO;

    try{
      setLoading(true);
      await privateAPI.post(`/auth/bacchus/admin/productgroup`, productGroupDTO);
      getAllGroups();
      setGroupDTO({});
      setCreateGroupOpen(false);
      setLoading(false);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const closeCreateGroupDialog = () => {
    setGroupDTO({});
    setCreateGroupOpen(false);
  }

  const deleteGroup = async (id) => {
    setIsProductGroupOpen(0);

    try{
      setLoading(true);
      await privateAPI.delete(`/auth/bacchus/admin/productgroup/${id}`);
      getAllGroups();
      setLoading(false);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const deleteProduct = async (id, groupId) => {
    try{
      setLoading(true);
      const response = await privateAPI.delete(`/auth/bacchus/admin/product/${id}`);
      getProductsFromGroup(groupId);
      setLoading(false);
      toast.success(response.data);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const openEditProduct = async (id, groupId) => {
    try {
      setEditProductGroupId(groupId);
      const response = await publicAPI.get(`/public/bacchus/product/${id}`);
      setProductDTO(response.data)
      setCreateProductOpen(true)
    } catch (error){
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const editProduct = async () => {
    if(!productDTO.productGroupId) return toast.info('Choose a group!');
    if(!productDTO.name) return toast.info('Name is required');
    if(!productDTO.description) return toast.info('Description is required');
    if(!productDTO.image) return toast.info('Image is required');

    try {
      setLoading(true);
      productDTO.image = productDTO.image ?? [];
      await privateAPI.put(`/auth/bacchus/admin/product/${productDTO.id}`, productDTO);
      getProductsFromGroup(editProductGroupId);
      setCreateProductOpen(false);
      setProductDTO({});
      setLoading(false);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const closeCreateProductDialog = () => {
    setProductDTO({});
    setCreateProductOpen(false);
  }

  const crateNewProduct = async () => {
    if(!productDTO.productGroupId) return toast.info('Choose a group!');
    if(!productDTO.name) return toast.info('Name is required');
    if(!productDTO.description) return toast.info('Description is required');
    if(!productDTO.image) return toast.info('Image is required');

    try{
      setLoading(true);
      productDTO.image = productDTO.image ?? [];
      await privateAPI.post(`/auth/bacchus/admin/product`, productDTO);
      setProductDTO({});
      setCreateProductOpen(false);
      setLoading(false);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  useEffect(() => {
    getAllGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setLoading(false)
  }, []);

  return (
    <TabPanel value="1">
      <MuiButtonWrapper>
        <Button 
          variant="outlined"
          className="shadow-on-elements first-button"
          onClick={() => [setCreateGroupOpen(true), setIsProductGroupOpen(0)]}>
            Add New Group
        </Button>
        <Button 
          variant="outlined" 
          className="shadow-on-elements"
          onClick={() => setCreateProductOpen(true)}
          >
            Add New Product
        </Button>
      </MuiButtonWrapper>
      <SearchBar
        onChange={(searchVal) => requestSearch(searchVal)}
        style={{ marginBottom: '30px', border: '1px solid #001753', boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)' }}
        />
      <GroupProductTable 
        items={rows} 
        isGroups={true} 
        getProductsFromGroup={getProductsFromGroup} 
        isProductGroupOpen={isProductGroupOpen}
        closeAccording={closeAccording}
        productsFromGroup={productsFromGroup}
        deleteGroup={deleteGroup}
        openEditGroup={openEditGroup}
        deleteProduct={deleteProduct}
        openEditProduct={openEditProduct}
        />
      <CreateEditGroupDialog 
        open={createGroupOpen}
        closeCreateGroupDialog={closeCreateGroupDialog}
        crateNewGroup={crateNewGroup}
        setGroupDTO={setGroupDTO}
        groupDTO={groupDTO}
        editGroup={editGroup}
        />
      <CreateEditProductDialog 
        open={createProductOpen}
        closeCreateProductDialog={closeCreateProductDialog}
        crateNewProduct={crateNewProduct}
        setProductDTO={setProductDTO}
        productDTO={productDTO}
        editProduct={editProduct}
        />
      <Backdrop
        sx={{ color: '#fff', zIndex: 1000 }}
        open={loading}
        >
          <CircularProgress color="inherit" />
      </Backdrop>
    </TabPanel>
  );
};

export default AdminGroups;
